import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/app/category/` + url, ...arg)

export default {
	withApps(data) {
		return request('withApps', data, 'get')
	},
	categoryPage(data) {
		return request('page', data, 'get')
	},
	categoryAdd(data) {
		return request('add', data, 'post')
	},
	categoryEdit(data) {
		return request('edit', data, 'post')
	},
	categoryDelete(data) {
		return request('delete', data, 'post')
	},
	appPage(data) {
		return baseRequest('/biz/app/info/page', data, 'get')
	},
	appAdd(data) {
		return baseRequest('/biz/app/info/add', data, 'post')
	},
	appEdit(data) {
		return baseRequest('/biz/app/info/edit', data, 'post')
	},
	appDelete(data) {
		return baseRequest('/biz/app/info/delete', data, 'post')
	}
}
